import type { IconData } from '@uikit/svg-icon/types';

import type { Icon } from './types';

export function getIcon(iconName: Icon, size = 20): IconData {
    return {
        id: iconName,
        viewBox: `0 0 ${size} ${size}`,
        url: `/images/sprite.svg#${iconName}`,
    };
}
